import { useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { UrlHelper } from '@/utils/UrlHelper';
import { BookedApartmentListItemDtoListResponseDto, CalendarEventType } from '@/features/calendar/types/calendar-dto';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {
    startDate: Date;
    endDate: Date;
    types?: CalendarEventType[];
} & ApiHookProps;

export const useBookedApartmentsApi = ({startDate, endDate, types}: Props) => {
    const axiosInstance = useAxiosAuth();

    const {
        data: bookedApartmentsData, 
        isLoading: isLoadingBookedApartmentsData, 
        isError: isErrorBookedApartmentsData,
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.apartments.queryKeys.apartmentsLookup,
            startDate, endDate, types
        ],
        queryFn: async (): Promise<BookedApartmentListItemDtoListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.apartments.endpoints.apartmentsLookup, {                      
                startDate: DateTimeHelper.getDateOnly(startDate), 
                endDate: DateTimeHelper.getDateOnly(endDate), 
                types
            });
            const response = await axiosInstance.get<BookedApartmentListItemDtoListResponseDto>(url);
            return response.data;
        },      
    });


    return {
        bookedApartmentsData,
        isLoadingBookedApartmentsData,
        isErrorBookedApartmentsData,
    }
}